import clsx from "clsx";
import React from "react";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./color-pills.module.css";

export interface ColorPill {
    id?: string;
    url: string;
    label: string;
    color: string;
    checked: boolean;
    className?: string;
    onClick: () => void;
}

interface ColorPillsProps {
    pills: ColorPill[];
    className?: string;
}

export function ColorPills({ pills, className }: ColorPillsProps): JSX.Element {
    return (
        <ul className={clsx(styles.wrapper, className)}>
            {pills.map((pill) => (
                <li key={pill.id}>
                    <a
                        role="menuitemcheckbox"
                        aria-checked={pill.checked}
                        href={pill.url}
                        tabIndex={0}
                        onClick={(event) => {
                            event.preventDefault();
                            pill.onClick();
                        }}
                        className={clsx(styles.colorPill, pill.className, {
                            [styles.selected]: pill.checked,
                        })}
                    >
                        <div className={clsx(styles.colorSwatch, styles[pill.color])} />
                        {pill.label}
                    </a>
                </li>
            ))}
        </ul>
    );
}
